export default __webpack_public_path__ + "static/hero-recruiters-3dddfcaaee2f6b2f9ad51d6be0772df2.svg";